// A stable per-device id, unrelated to login/guest auth (those change on every anonymous
// session). Used only to give each device its own daily-card draw so a table of friends
// scanning the same restaurant on the same day don't all see the same quote.
const KEY = 'assaggioo_visitor_id';

export function getVisitorId(): string {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = (crypto.randomUUID?.() as string) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    // storage blocked (private mode, etc.) — fall back to a per-tab id, worse than nothing
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}
